<template>
  <div>
    <span
      v-for="(item, index) in checkedCities"
      :key="index"
    >{{ item }}</span>
    <el-input v-model="inputVal" />
    <div @click="clickFun">
      点击展示 选择视频弹窗
    </div>

    <el-dialog
      title="test"
      :visible.sync="showType"
      :before-close="cancelAction"
      width="820px"
    >
      <div>
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          全选
        </el-checkbox>
        <div style="margin: 15px 0" />
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="city in cities"
            :key="city"
            :label="city"
          >
            {{ city }}
          </el-checkbox>
        </el-checkbox-group>
        <el-button
          type="primary"
          @click="saveAction"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const cityOptions = ['上海', '北京', '广州', '深圳']
export default {
  name: 'SPInputConfig',
  props: {
    videoData: {
      type: String
    }
  },
  data () {
    return {
      inputVal: null,
      showType: false,
      checkAll: false,
      checkedCities: ['上海', '北京'],
      cities: cityOptions,
      isIndeterminate: true
    }
  },
  watch: {},
  created () {},
  methods: {
    clickFun () {
      this.$emit('getVideo', 'Video')
      this.showType = true
    },
    cancelAction () {
      this.showType = false
    },
    saveAction () {
      this.showType = false
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    }
  }
}
</script>

<style scoped lang="scss"></style>
